import BrandButton from "@components/Various/BrandButton";
import React, { FormEvent } from "react";

function BaseAuthForm({
  children,
  action,
  onSubmit,
}: {
  children: React.ReactNode;
  action: string;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
}) {
  return (
    <form onSubmit={onSubmit}>
      {children}

      <BrandButton type="submit" className="py-3">
        {action}
      </BrandButton>
    </form>
  );
}

export default BaseAuthForm;
